import { cn } from "@/common/utils/css.utils";

/**
 * The visitor's photo as a filled square, cropped around the centre (WHO-6534, Dieke 4 Nov).
 * A background, not an `<img>` with object-fit: on Dieke's browser the image kept its own ratio
 * and left white bands beside a portrait photo. Decorative: the item's name sits next to it.
 */
export const ValueCheckThumb = ({
  photoUrl,
  className,
  "data-testid": testId,
}: {
  photoUrl: string;
  className?: string;
  "data-testid"?: string;
}) => (
  <span
    aria-hidden
    className={cn(
      "block shrink-0 rounded bg-grey-100 bg-cover bg-center bg-no-repeat",
      className
    )}
    style={{ backgroundImage: `url("${photoUrl}")` }}
    data-testid={testId}
  />
);
